<script>

    import { createEventDispatcher } from 'svelte';
    import Modal from "../UI/Modal.svelte";
    import Button from "../UI/Button.svelte";
    import SeedsList from "./SeedsList.svelte"

    export let plantName;
    var title =`Pick your ${plantName} Seeds`
    
    const dispatch = createEventDispatcher()
    
    
    export let exploreMode;
    export let seedSubset;

  
    function cancelModal() {
        dispatch('cancel')
    }
    </script>
    
    <style>

    </style>
    
    <Modal title={title} on:cancel>  
        <SeedsList 
        {exploreMode} 
        {seedSubset}
        on:buy-now
        />
        <div slot="footer">
            <Button 
            mode= "outline" 
            type= "button" 
            on:click={cancelModal}>
            
            back</Button>
        </div>
    </Modal>